// eslint-disable-next-line import/no-unresolved
import configFile from 'static:./config.json'

import { ConnectwareError, ConnectwareErrorType } from '../../domain'

import { defaultConfiguration } from '../config'
import configurables from '../config/configurables.json'
import { ConfigurationCustomizer } from './ConfigurationCustomizer'

const customizer = new ConfigurationCustomizer(defaultConfiguration, configurables)

const configPromise = fetch(configFile)
    .then<unknown>((response) => response.json())
    .then((customConfig) => customizer.addCustomConfig(customConfig))
    .catch((error: Error) =>
        customizer.addError(
            new ConnectwareError(ConnectwareErrorType.UNEXPECTED, 'Could not load or parse custom config file', { file: configFile, error: error.message })
        )
    )

export default configPromise
